import styled from 'styled-components';

import {Device} from '../../constants';

const ImageOnlyDesktop = styled.img`
  max-width: 100%;
  max-height: 100%;
  display: inline;
  @media only screen and ${Device.tablet} {
    display: none;
  }
`;

export default ImageOnlyDesktop;
